import { useState, useEffect } from "react";

export function useIsMobile(breakpoint = 767) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= breakpoint);
  const [isTablet, setIsTablet] = useState(() => window.innerWidth <= 1199 && window.innerWidth > breakpoint);

  useEffect(() => {
    const handler = () => {
      const w = window.innerWidth;
      setIsMobile(w <= breakpoint);
      setIsTablet(w <= 1199 && w > breakpoint);
    };
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, [breakpoint]);

  return { isMobile, isTablet, isDesktop: !isMobile && !isTablet };
}
